import BaseService from './base/base.service.js'

export default class MembersAreaService extends BaseService {

    constructor(){
        super('members')
    }

}